'use client'

import { useAtomValue, useSetAtom } from 'jotai/react'
import Image from 'next/image'
import { walletAccountsAtom } from '@/src/stores/accounts/wallets'
import {
  onboardingDialogAtom,
  openOnboardingDialog,
} from '@/src/stores/onboarding'
import { Button } from '../ui/button'

/**
 * Original LoginIntro component - shows when privacyUi FF is OFF
 */
export function LoginIntro() {
  const connectedWallets = useAtomValue(walletAccountsAtom)
  const showAccountModeIntro =
    (connectedWallets?.groupedAccounts?.length ?? 0) > 0

  return showAccountModeIntro ? <AccountModeIntro /> : <GuestModeIntro />
}

function GuestModeIntro() {
  const setOnboardingDialog = useSetAtom(onboardingDialogAtom)

  return (
    <div className='flex flex-col gap-16 items-center justify-between pt-12'>
      <h6 className='text-5xl font-serif font-extralight text-center'>
        Start your trading <span className='italic'>adventure</span>.
      </h6>
      <div className='flex flex-col sm:flex-row items-center gap-6 max-w-[960px] px-8 mx-auto'>
        <div className='flex flex-col p-8 rounded-3xl relative h-[512px] overflow-hidden'>
          <div className='flex flex-col gap-6 relative z-10 items-center'>
            <div className='flex flex-col gap-3 text-center'>
              <span className='text-xl font-semibold'>
                Build your portfolio
              </span>
              <span>
                Track your portfolio wherever you are, with personalized
                insights and more.
              </span>
            </div>
            <Button
              type='button'
              variant='primary'
              className='font-semibold'
              onClick={() => {
                setOnboardingDialog(openOnboardingDialog('login'))
              }}
            >
              Sign up for free
            </Button>
          </div>
          <Image
            src='https://s3.polaris.app/artworks/girl-backpack-field-house.png'
            alt=''
            fill
            className='object-cover'
            sizes='100vw'
          />
        </div>
        <span className='text-sm text-secondary'>OR</span>
        <div className='flex flex-col p-8 rounded-3xl relative h-[512px] overflow-hidden'>
          <div className='flex flex-col gap-6 relative z-10 items-center'>
            <div className='flex flex-col gap-3 text-center'>
              <span className='text-xl font-semibold'>
                Start without an account
              </span>
              <span>
                Connect and start trading instantly. Polaris won&apos;t remember
                you or your wallets.
              </span>
            </div>
            <Button
              type='button'
              variant='primary'
              className='font-semibold bg-gray-100 hover:bg-gray-200'
              onClick={() => {
                setOnboardingDialog(openOnboardingDialog('wallets'))
              }}
            >
              Connect wallets
            </Button>
          </div>
          <Image
            src='https://s3.polaris.app/artworks/girl-backpack-camping.png'
            alt=''
            fill
            className='object-cover'
            sizes='100vw'
          />
        </div>
      </div>
    </div>
  )
}

function AccountModeIntro() {
  const setOnboardingDialog = useSetAtom(onboardingDialogAtom)

  return (
    <div className='relative max-w-4xl w-full mx-auto flex sm:flex-row flex-col items-center rounded-3xl overflow-hidden h-[456px] sm:h-[228px] mt-12'>
      <div className='relative z-10 flex flex-col gap-6 p-6 sm:p-8 sm:pr-0 w-full max-sm:h-[calc(100%-128px)] sm:w-[calc(50%+128px)] bg-gradient-to-b sm:bg-gradient-to-r from-foreground via-80% via-foreground to-transparent'>
        <div className='flex flex-col gap-3'>
          <span className='text-xl font-semibold'>Save your portfolio</span>
          <span className='text-secondary max-w-[381px]'>
            Track your portfolio wherever you are, with personalized insights
            and more.
          </span>
        </div>
        <Button
          variant='primary'
          className='font-semibold'
          onClick={() => {
            setOnboardingDialog(openOnboardingDialog('login'))
          }}
        >
          Sign up for free
        </Button>
      </div>
      <Image
        src='https://s3.polaris.app/artworks/girl-backpack-field-house.png'
        alt=''
        width={1230}
        height={1230}
        className='object-cover absolute w-full bottom-0 sm:right-0 sm:-bottom-12 sm:w-1/2'
      />
    </div>
  )
}
